import { Hourglass } from 'lucide-react';

import SecurityLayout from '../../components/security/SecurityLayout';

export default function SuspendedPage() {
  return (
    <SecurityLayout
      variant="suspended"
      icon={Hourglass}
      title={`Acesso temporariamente\nsuspenso`}
      description="Seu acesso encontra-se temporariamente suspenso. Entre em contato com nossa equipe para obter mais informações e regularizar sua situação."
      footerText="Caso necessário, nossa equipe poderá fornecer orientações adicionais."
    />
  );
}